/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';

export const ChipsBag = styled.div`
  width: 130px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
